
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import MobileHeader from "../../components/header/MobileHeader";
import LoginHeader from "../../components/header/LoginHeader";
import Footer from "../../components/footer";
import Gotop from "../../components/gotop";
import Approval from "./Approval";
import Breadcrumb from "../../components/breadcrumb";
import LoginMobileHeader from "../../components/header/LoginMobileHeader";

ApprovalProcess.propTypes = {};

function ApprovalProcess(props) {

    const [isShowMobile, setShowMobile] = useState(false);



    const handleMobile = () => {
        const getMobile = document.querySelector(".menu-mobile-popup");
        setShowMobile(!isShowMobile);
        !isShowMobile
            ? getMobile.classList.add("modal-menu--open")
            : getMobile.classList.remove("modal-menu--open");
    };

    useEffect(() => {
        const WOW = require("wowjs");
        window.wow = new WOW.WOW({
            live: false,
        });
        window.wow.init();
    }, []);

    return (
        <>
            <LoginMobileHeader handleMobile={handleMobile} />
            <LoginHeader clname="act1" handleMobile={handleMobile} />
            <Breadcrumb title="Approval Process" className="breadcrumb-section" />
            <Approval />
            {/* <Footer /> */}
            <Gotop />
        </>
    );
}

export default ApprovalProcess;
